/* eslint-disable @typescript-eslint/no-explicit-any */
import { UUID } from "node:crypto";
import { baseApi } from "./baseApi";
import { ResponseData } from "@interfaces/response";
import { VISUAL_CONFIG_CODES, VisualConfigCode } from "@helpers/constantes";
import { ChecklistSectionDocuments, ChecklistDocuments } from "@interfaces/catalogs";
import { normalizeChecklistSectionDocuments, normalizeChecklistDocuments } from "@components/CustomCheckList/functions";

export type VisualConfigValue = ChecklistSectionDocuments | ChecklistDocuments;

const catalogosApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getVisualConfig: build.query<VisualConfigValue, { tax_system_id: UUID; code: VisualConfigCode }>({
      query: ({ tax_system_id, code }) => `configuraciones/onboarding?tax_system_id=${tax_system_id}&code=${code}`,
      transformResponse: (response: ResponseData<any>, _meta, arg) => {
        const value = response?.data;

        if (arg.code === VISUAL_CONFIG_CODES.CHECKLIST_EXPEDIENTE) {
          return normalizeChecklistSectionDocuments(value);
        }

        if (
          arg.code === VISUAL_CONFIG_CODES.CHECKLIST_VISITA_OCULAR ||
          arg.code === VISUAL_CONFIG_CODES.CHECKLIST_FIRMA
        ) {
          return normalizeChecklistDocuments(value);
        }

        return Array.isArray(value) ? value : [];
      },
    }),
  }),
});

export const { useLazyGetVisualConfigQuery } = catalogosApi;
